import axios from 'axios'
import { PRESUPUESTADOR_ENDPOINT } from '../../endpoints'

export async function retryOfferDMS(id) {
  const response = await axios.put(`${PRESUPUESTADOR_ENDPOINT}/retryIntegration/${id}`)
  return response?.data?.data
}
